export default __webpack_public_path__ + "static/media/controls_applicable.ca5099c6.svg";